import React from "react";
import Text from "../../styleguide/Text";
import LoadingIndicator from "./LoadingIndicator";

type CardProps = {
  children: React.ReactNode | JSX.Element | JSX.Element[];
  cardTitle?: string;
  cardSubtitle?: string;
  CardHeader?: () => React.ReactNode | JSX.Element | JSX.Element[];
  CardFooter?: () => React.ReactNode | JSX.Element | JSX.Element[];
  className?: string;
  cardBodyClassName?: string;
  cardHeaderClassName?: string;
  cardFooterClassName?: string;
  cardTitleClassName?: string;
  cardSubtitleClassName?: string;
  cardContainerStyle?: React.CSSProperties;
  cardBodyStyle?: React.CSSProperties;
  cardHeaderStyle?: React.CSSProperties;
  cardFooterStyle?: React.CSSProperties;
  cardTitleStyle?: React.CSSProperties;
  cardSubtitleStyle?: React.CSSProperties;
  fullWidth?: boolean;
  isLoading?: boolean;
  isLoadingClassName?: string;
  onClick?: () => void;
  withShadow?: boolean;
  withPadding?: boolean;
  withMargin?: boolean;
};

function ContentCard({
  children,
  cardTitle,
  cardSubtitle,
  CardHeader,
  CardFooter,
  className = "",
  cardHeaderClassName = "",
  cardTitleClassName = "",
  cardSubtitleClassName = "",
  cardBodyClassName = "",
  cardFooterClassName = "",
  cardContainerStyle,
  cardHeaderStyle,
  cardTitleStyle,
  cardSubtitleStyle,
  cardBodyStyle,
  cardFooterStyle,
  fullWidth = false,
  isLoading,
  isLoadingClassName = "flex items-center justify-center",
  onClick,
  withShadow = true,
  withPadding = true,
  withMargin = true,
}: CardProps) {
  const handleOnClick = () => {
    if (isLoading) return;
    onClick && onClick();
  };
  return (
    <div
      className={`${withShadow ? "shadow-xs" : ""} min-w-0 rounded-card ${
        withMargin ? "mx-3 mb-9" : ""
      } ${withPadding ? "px-6 py-8" : ""} bg-white ${className ?? ""} ${
        fullWidth ? "w-full" : ""
      }`}
      style={cardContainerStyle}
      onClick={handleOnClick}>
      {(CardHeader || cardTitle || cardSubtitle) && (
        <div
          className={`border-0 pt-5 ${cardHeaderClassName}`}
          style={cardHeaderStyle}>
          {cardTitle && (
            <Text
              variant="h3"
              component="h3"
              className={`mb-4 font-semibold text-slate-900 ${cardTitleClassName}`}
              style={cardTitleStyle}
              gutterBottom>
              {cardTitle}
            </Text>
          )}
          {cardSubtitle && (
            <Text
              variant="h4"
              component="h4"
              className={cardSubtitleClassName}
              style={cardSubtitleStyle}
              gutterBottom>
              {cardSubtitle}
            </Text>
          )}
          {CardHeader && CardHeader()}
        </div>
      )}
      {isLoading ? (
        <div className={`${isLoadingClassName}`}>
          <LoadingIndicator />
        </div>
      ) : (
        <div
          className={`relative overflow-auto ${cardBodyClassName}`}
          style={cardBodyStyle}>
          {children}
        </div>
      )}
      {CardFooter && (
        <div
          className={`border-t border-slate-200 ${cardFooterClassName}`}
          style={cardFooterStyle}>
          {CardFooter()}
        </div>
      )}
    </div>
  );
}

export default ContentCard;
